export const BRANDS_CREATE_BRAND = 'BRANDS_CREATE_BRAND'
export const BRANDS_DELETE_BRAND = 'BRANDS_DELETE_BRAND'
export const BRANDS_FETCH_ALL = 'BRANDS_FETCH_ALL'
export const BRANDS_UPDATE_BRAND = 'BRANDS_UPDATE_BRAND'
export const BRANDS_OPTIMISTIC_BRAND_UPDATE = 'BRANDS_OPTIMISTIC_BRAND_UPDATE'
